// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3XMem","productName":"Table_productName__2iyDI"};